import {ReactComponent as Icon} from "./man.svg"

type StopwatchIconProps = {
	className?: string;
};

const ManIcon: React.FunctionComponent<StopwatchIconProps> = ({className}) => {
	return <Icon className={className}/>;
};

export default ManIcon;